import React from 'react';
import { trackAddToCart } from '../../hooks/useMetaPixel';
interface ButtonProps {
  children: React.ReactNode;
  subtext?: string;
  className?: string;
  href?: string;
}
export function Button({
  children,
  subtext,
  className = '',
  href
}: ButtonProps) {
  const classes = `group relative inline-flex flex-col items-center justify-center bg-gold text-teal font-bold py-4 px-8 rounded-full shadow-lg hover:shadow-glow transition-all duration-300 transform hover:-translate-y-1 ${className}`;
  const content = <>
      <span className="text-lg md:text-xl tracking-wide" data-id="element-135">{children}</span>
      {subtext && <span className="text-sm md:text-base font-normal mt-1 opacity-90 group-hover:opacity-100 transition-opacity" data-id="element-136">
          {subtext}
        </span>}
    </>;
  const handleClick = () => {
    if (href) {
      trackAddToCart();
    }
  };
  if (href) {
    return <a href={href} target="_blank" rel="noopener noreferrer" className={classes} onClick={handleClick} data-id="element-137">
        {content}
      </a>;
  }
  return <button className={classes} data-id="element-138">{content}</button>;
}